import { Navigate, NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../state/AuthContext';
import { TopBar } from '../components/TopBar';

export function AdminLayout() {
  const { user, loading } = useAuth();

  if (loading) return <div className="center-screen"><div className="loading-state">Loading…</div></div>;
  if (!user) return <Navigate to="/" replace />;
  // Every admin API call is independently protected server-side by
  // ADMIN_EMAIL; this client check only prevents a non-admin from seeing
  // the admin shell render before an API call would reject it anyway.
  if (!user.isAdmin) return <Navigate to="/onboarding/country" replace />;

  return (
    <div className="app-shell">
      <TopBar />
      <div className="page-container page-container-admin">
        <nav className="admin-user-tabs" aria-label="Admin sections">
          <NavLink end to="/admin" className={({ isActive }) => (isActive ? 'active' : undefined)}>Applicants</NavLink>
          <NavLink to="/admin/positions" className={({ isActive }) => (isActive ? 'active' : undefined)}>Positions</NavLink>
          <NavLink to="/admin/application-preview" className={({ isActive }) => (isActive ? 'active' : undefined)}>Application forms</NavLink>
        </nav>
        <Outlet />
      </div>
    </div>
  );
}
